import { PARTNER_TYPES } from '../../partner-types';
import { Roles } from '../../roles';
import { MenuItem } from '../types';

export const developerHubSection: MenuItem[] = [
  {
    headTitle1: 'Internal Developer Hub',
    type: 'headtitle',
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
  },
  {
    path: '/internal-developer-hub/overview',
    title: 'Overview',
    icon: 'stroke-home',
    iconf: 'fill-home',
    type: 'link',
    active: false,
    requiredUserGroup: ['ryd'],
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
  },
  {
    path: '/internal-developer-hub/usage-overview',
    title: 'Usage Overview',
    icon: 'stroke-reports-analytics',
    iconf: 'fill-reports-analytics',
    type: 'link',
    active: false,
    requiredUserGroup: ['ryd'],
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
  },
  {
    title: 'API Documentation',
    icon: 'stroke-bookmark',
    iconf: 'fill-bookmark',
    type: 'sub',
    active: false,
    requiredUserGroup: ['ryd'],
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    children: [
      {
        path: '/internal-developer-hub/api-docs',
        title: 'Catalogue',
        type: 'link',
        active: false,
        activePathPrefixes: [
          '/internal-developer-hub/api-docs',
          '/internal-developer-hub/services',
        ],
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
      },
      {
        path: '/internal-developer-hub/api-docs/manage',
        title: 'Manage Services',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        requiredRoles: [Roles.api_docs_admin],
      },
      {
        path: '/internal-developer-hub/api-docs/audit-log',
        title: 'Try-out Audit Log',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
        requiredRoles: [Roles.api_docs_admin],
      },
    ],
  },
  {
    title: 'Automated Tests',
    icon: 'stroke-user',
    iconf: 'fill-user',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    requiredRoles: [Roles.developer],
    children: [
      {
        path: '/internal-developer-hub/automated-tests/overview',
        title: 'Overview',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.developer],
      },
      {
        path: '/internal-developer-hub/automated-tests/trigger-builder',
        title: 'AI & Webhook Triggers',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.developer],
      },
      {
        path: '/internal-developer-hub/automated-tests/api-test-automation',
        title: 'API Test Automation',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.developer],
      },
      {
        path: '/internal-developer-hub/automated-tests/connect-test-automation',
        title: 'Connect Test Automation',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.developer],
      },
      {
        path: '/internal-developer-hub/automated-tests/odoo-test-automation',
        title: 'Odoo Test Automation',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.developer],
      },
      {
        path: '/internal-developer-hub/automated-tests/ryd-portal',
        title: 'ryd Portal Test Automation',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.developer],
      },
      {
        path: '/internal-developer-hub/automated-tests/webapp-test-automation',
        title: 'Webapp Test Automation',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.developer],
      },
    ],
  },
  {
    title: 'Developer Tools',
    icon: 'stroke-user',
    iconf: 'fill-user',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    requiredRoles: [Roles.developer],
    children: [
      {
        path: '/internal-developer-hub/developer-tools/api-tester',
        title: 'API Tester',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.developer],
      },
      {
        path: '/internal-developer-hub/developer-tools/api-doc-updater',
        title: 'API Doc Updater',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.developer],
      },
      {
        path: '/internal-developer-hub/developer-tools/ryd-portal-api-documentation',
        title: 'Portal API Doc',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.developer],
      },
      {
        path: '/internal-developer-hub/developer-tools/feedback-attachments-guide',
        title: 'Feedback Attachments',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.developer],
      },
    ],
  },
  {
    title: 'Odoo',
    icon: 'stroke-user',
    iconf: 'fill-user',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    requiredRoles: [Roles.developer],
    children: [
      {
        path: '/internal-developer-hub/odoo/getting-started',
        title: 'Getting Started',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.developer],
      },
      {
        path: '/internal-developer-hub/odoo/key-concepts',
        title: 'Key Concepts',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.developer],
      },
      {
        title: 'REST API',
        type: 'sub',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.developer],
        children: [
          {
            path: '/internal-developer-hub/odoo/rest-api/introduction',
            title: 'Introduction',
            type: 'link',
            active: false,
            requiredUserGroup: ['ryd'],
            requiredRoles: [Roles.developer],
          },
          {
            path: '/internal-developer-hub/odoo/rest-api/api-reference',
            title: 'API Reference',
            type: 'link',
            active: false,
            requiredUserGroup: ['ryd'],
            requiredRoles: [Roles.developer],
          },
          {
            path: '/internal-developer-hub/odoo/rest-api/transitory-data',
            title: 'Transitory Data',
            type: 'link',
            active: false,
            requiredUserGroup: ['ryd'],
            requiredRoles: [Roles.developer],
          },
          {
            path: '/internal-developer-hub/odoo/rest-api/idempotency',
            title: 'Idempotency',
            type: 'link',
            active: false,
            requiredUserGroup: ['ryd'],
            requiredRoles: [Roles.developer],
          },
          {
            path: '/internal-developer-hub/odoo/rest-api/order-lifecycle',
            title: 'Order Lifecycle',
            type: 'link',
            active: false,
            requiredUserGroup: ['ryd'],
            requiredRoles: [Roles.developer],
          },
        ],
      },
      {
        title: 'XML-RPC API',
        type: 'sub',
        active: false,
        requiredUserGroup: ['ryd'],
        requiredRoles: [Roles.developer],
        children: [
          {
            path: '/internal-developer-hub/odoo/xmlrpc-api/introduction',
            title: 'Introduction',
            type: 'link',
            active: false,
            requiredUserGroup: ['ryd'],
            requiredRoles: [Roles.developer],
          },
          {
            path: '/internal-developer-hub/odoo/xmlrpc-api/odoo-model-explorer',
            title: 'Odoo Model Explorer',
            type: 'link',
            active: false,
            requiredUserGroup: ['ryd'],
            requiredRoles: [Roles.developer],
          },
        ],
      },
    ],
  },
  {
    title: 'Discount Management',
    icon: 'stroke-user',
    iconf: 'fill-user',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: '/internal-developer-hub/discount-management/introduction',
        title: 'Introduction',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/internal-developer-hub/discount-management/list-price-guide',
        title: 'List Price Integration',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/internal-developer-hub/discount-management/api-reference',
        title: 'API Reference',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
    ],
  },
  {
    title: 'UI Settings API',
    icon: 'stroke-palette',
    iconf: 'fill-palette',
    type: 'sub',
    active: false,
    requiredPartnerTypes: [PARTNER_TYPES.RYD_INTERNAL],
    requiredUserGroup: ['ryd'],
    children: [
      {
        path: '/internal-developer-hub/ui-settings/overview',
        title: 'Overview',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/internal-developer-hub/ui-settings/integration-guide',
        title: 'Integration Guide',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
      {
        path: '/internal-developer-hub/ui-settings/api-reference',
        title: 'API Reference',
        type: 'link',
        active: false,
        requiredUserGroup: ['ryd'],
      },
    ],
  },
];
